import { atom } from 'recoil'

export const myStoreModalState = atom<boolean>({
  key: 'myStoreModalState',
  default: false,
})
